import React, {FC, useCallback, useEffect, useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useNavigate} from 'react-router-native';
import {useDevice} from '@lookiero/aurora';
import {Path} from '../../../../../modules/routing/routes.definition';
import {TEXT} from './NavOptions.definition';
import {Skeleton} from '@components/molecules/NavigationBar/NavOptions/Skeleton';
import {useLookIn} from '@modules/look-in/ui/hooks/useLookIn';
import {Footer, FooterItem} from '@components/templates/footer/Footer';
import {style as navOptionsStyle} from './NavOptions.style';

const MAXIMUM_LOADING_TIME = 1000;

const NavOptions: FC = () => {
  const [showNavWithoutWaitingForLoadingToFinish, setShowNavWithoutWaitingForLoadingToFinish] = useState(false);
  const {enabled: isLookInEnabled, loading} = useLookIn();
  const {screen} = useDevice();
  const {formatMessage} = useIntl();
  const navigate = useNavigate();

  const style = useMemo(() => navOptionsStyle(), []);
  const panelStyle = screen.L ? style.panelLarge : style.panel;

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowNavWithoutWaitingForLoadingToFinish(true);
    }, MAXIMUM_LOADING_TIME);

    return () => clearTimeout(timeoutId);
  }, [setShowNavWithoutWaitingForLoadingToFinish]);

  const handleOnChange = useCallback((path: Path) => navigate(path), [navigate]);

  const data: FooterItem[] = useMemo(
    () => [
      {icon: 'home', label: formatMessage(TEXT.HOME), path: Path.HOME, testID: 'navbar-home'},
      {
        icon: 'shop',
        label: formatMessage(TEXT.LOOK_IN),
        path: Path.LOOK_IN_HOME,
        testID: 'navbar-look-in',
        hidden: !isLookInEnabled,
      },
      {icon: 'referrals', label: formatMessage(TEXT.FRIENDS), path: Path.REFERRALS, testID: 'navbar-raf'},
      {icon: 'profile', label: formatMessage(TEXT.PROFILE), path: Path.PROFILE_MENU, testID: 'navbar-profile'},
    ],
    [formatMessage, isLookInEnabled],
  );

  if (loading && !showNavWithoutWaitingForLoadingToFinish) return <Skeleton />;

  return <Footer onChange={handleOnChange} data={data} style={panelStyle} />;
};

export {NavOptions};
